import { routes } from '@/router/index';
import stopper from '@/utils/stopper';
import { getLanguageLong } from '@/utils/locale';
// 统一增加沉浸式 query
export function addNativeWebUIType(to, from, next) {
  let { nativeWebUIType, ...newQuery } = to.query || {};
  if (+nativeWebUIType === 2) {
    next();
  } else {
    nativeWebUIType = 2;
    next({
      ...to,
      query: {
        ...newQuery,
        nativeWebUIType,
      },
      replace: true,
    });
  }
}
// 劫持 push replace方法拦截错误
export function routerRedirectCatch(Router) {
  // https://blog.csdn.net/mm0715/article/details/112768494
  const originalPush = Router.prototype.push;
  const originalReplace = Router.prototype.replace;

  Router.prototype.push = function (location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location).catch((err) => err);
  };

  Router.prototype.replace = function (location, onResolve, onReject) {
    if (onResolve || onReject) {
      return originalReplace.call(this, location, onResolve, onReject);
    }
    return originalReplace.call(this, location).catch((err) => err);
  };
}

// 过滤，打平得到侧边导航配置
export const sideMenus = routes
  .filter((route) => route.meta?.sideMenu?.label)
  .map((route) => ({ ...route, ...route.meta.sideMenu }))
  .sort((pre, next) => {
    let preWeight = pre?.weight || 0;
    let nextWeight = next?.weight || 0;
    return nextWeight - preWeight;
  });

// 提单页 拦截刷新跳转逻辑处理
export function handelStopper(next) {
  if (stopper.open) {
    stopper.routerAlert().then((res) => {
      if (res) {
        stopper.end();
        next();
      }
    });
  } else {
    next();
  }
}

export const dontNeedLoginRouteMap = routes
  .filter((route) => route.meta?.useLogin === false)
  .reduce((pre, next) => {
    pre[`/${getLanguageLong()}/entrega-business${next.path}`] = true;
    return pre;
  }, {});
